import * as PIXI from 'pixi.js'

import TYPES from '../utils/types'

export const Container = (root, props) => {
  const $el = new PIXI.Container()
  return $el
}

export default TYPES.Container
